module.exports = __webpack_public_path__ + "static/Button_Appstore-13132680300d21aca5ac124693ce4fc0.png";